import { render, staticRenderFns } from "./RemindPerformance.vue?vue&type=template&id=7e0e27dc&scoped=true&"
import script from "./RemindPerformance.vue?vue&type=script&lang=js&"
export * from "./RemindPerformance.vue?vue&type=script&lang=js&"
import style0 from "./RemindPerformance.vue?vue&type=style&index=0&id=7e0e27dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0e27dc",
  null
  
)

export default component.exports